module.exports = __webpack_public_path__ + "img/id-card.48cc7afc.png";